export default "__VITE_ASSET__CV6UT9Jg__"